'use client'

import Script from 'next/script'

import { Language, TLanguage } from '../../model/language'

type Props = {
  id: string
  language?: TLanguage
  onReady: () => void
}

export const NaverMap = ({ id, language = Language.KO, onReady }: Props) => {
  return (
    <>
      <Script
        type="text/javascript"
        src={`https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.NEXT_PUBLIC_NCP_CLIENT_ID}&language=${language}`}
        onReady={onReady}
      />
      <div id={id} style={{ width: '100%', height: '100%' }} />
    </>
  )
}
